export const FETCH_LIVE_STREAMS_BEGIN = 'marquee/FETCH_LIVE_STREAMS_BEGIN';
export const FETCH_LIVE_STREAMS_SUCCESS = 'marquee/FETCH_LIVE_STREAMS_SUCCESS';
export const FETCH_LIVE_STREAMS_ERROR = 'marquee/FETCH_LIVE_STREAMS_ERROR';

export const FETCH_SURVEYS_BEGIN = 'marquee/FETCH_SURVEYS_BEGIN';
export const FETCH_SURVEYS_SUCCESS = 'marquee/FETCH_SURVEYS_SUCCESS';
export const FETCH_SURVEYS_ERROR = 'marquee/FETCH_SURVEYS_ERROR';

export const FETCH_SURVEYS_CAN_BE_TAKEN_BEGIN = 'marquee/FETCH_SURVEYS_CAN_BE_TAKEN_BEGIN';
export const FETCH_SURVEYS_CAN_BE_TAKEN_SUCCESS = 'marquee/FETCH_SURVEYS_CAN_BE_TAKEN_SUCCESS';
export const FETCH_SURVEYS_CAN_BE_TAKEN_ERROR = 'marquee/FETCH_SURVEYS_CAN_BE_TAKEN_ERROR';

export const GO_BACK_TO_SURVEYS = 'marquee/GO_BACK_TO_SURVEYS';
export const CLOSE_SURVEY_MODAL = 'marquee/CLOSE_SURVEY_MODAL';
export const SHOW_SURVEY_MODAL = 'marquee/SHOW_SURVEY_MODAL';
export const SHOW_SURVEY_FROM_ID = 'marquee/SHOW_SURVEY_FROM_ID';
